import {
  appVersion,
  numbers,
  specialChars,
  description,
  topRightUELogoEnabled,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes,
  applicationSubmittedTo
} from './base.config';

export const environment = {
  appVersion,
  specialChars,
  numbers,
  description,
  topRightUELogoEnabled,
  appLogoTopUrl,
  appLogoBottomUrl,
  showFooterEULogotypes,
  applicationSubmittedTo,
  exposedMapTargetOrigin: 'https://public-map-test.zdp.rde.pl',
  production: false,
  // apiBasePath: 'https://euslugi.zdp.rde.pl/system/api/v1',
  // apiBasePath: 'https://zdp-debica.test.aspello.pl/system/api/v1',
  apiBasePath: 'https://euslugi-test.zdp.rde.pl/system/api/v1',
  ssl: false
};
